import { IProvidersResponseData } from '.';
import { IFilterModel } from '@components/widgets/listing-widget';
import { IAbstractRecord } from '@models';
import { IListingData } from '@models/listing';
import DateService from '@services/DateService';
import FormattingService from '@services/FormattingService';
import {
  enumListAsRecordObject,
  lookupListAsRecordObject,
} from '@utils/graph-utils';

export function mapToListingData(data: IAbstractRecord): IListingData {
  const list: IAbstractRecord = {};

  data.Configuration.queries.getProviderList.items.forEach(
    (obj: IProvidersResponseData) => {
      list[obj.configuration_Provider_Id] = {
        id: obj.configuration_Provider_Id,
        code: obj.configuration_Provider_ProviderCode,
        name: obj.configuration_Provider_PersonID?.views
          .SalesforceManagement_all.properties.FullName,
        type: obj.configuration_Provider_Type?.Title,
        email:
          obj.configuration_Provider_PersonID?.views.SalesforceManagement_all
            .properties.Email,
        phoneNumber:
          obj.configuration_Provider_PersonID?.views.SalesforceManagement_all
            .properties.PhoneDetails?.PhoneNumber,
        status: FormattingService.formatEnumToDisplay(
          obj.configuration_Provider_Status
        ),
        createdOn: obj.configuration_Provider_createdOn,
        modifiedOn: obj.configuration_Provider_modifiedOn,
      };
    }
  );

  return {
    pagedItems: list,
    pageSize: data.Configuration.queries.getProviderList?.paging?.pageSize,
    pageNumber: data.Configuration.queries.getProviderList?.paging?.pageNumber,
    totalCount: data.Configuration.queries.getProviderList?.paging?.totalCount,
  };
}

export function toLookups(data: IAbstractRecord) {
  const lovs: Record<string, Record<string, string>> = {
    type: {},
    status: {},
  };

  lovs.type = lookupListAsRecordObject(
    data?.Configuration?.lookups?.providerTypes
  );
  lovs.status = enumListAsRecordObject(
    data?.Configuration_ProviderStatuses?.enumValues
  );

  return lovs;
}

export const getVariables = (filter: IFilterModel) => {
  const formattedCreatedDateRange = DateService.formatDateRangeBackend(
    filter.namedFilters.createdOn
  );
  const formattedEffectiveDateRange = DateService.formatDateRangeBackend(
    filter.namedFilters.effectiveDate
  );

  return {
    pagination: filter.pagination,
    selectedTypes:
      filter.namedFilters?.type?.length > 0 ? filter.namedFilters?.type : [],
    isCompany:
      filter.namedFilters?.isCompany.length === 1
        ? filter.namedFilters?.isCompany[0] === 'true'
        : null,
    isLocal:
      filter.namedFilters?.isLocal.length === 1
        ? filter.namedFilters?.isLocal[0] === 'true'
        : null,
    providerStatus:
      filter.namedFilters?.status?.length === 1
        ? filter.namedFilters?.status[0]
        : null, 
    createdDateFrom: formattedCreatedDateRange?.[0],
    createdDateTo: formattedCreatedDateRange?.[1],
    effectiveDateFrom: formattedEffectiveDateRange?.[0],
    effectiveDateTo: formattedEffectiveDateRange?.[1],
    KeywordSearch: filter.searchKey,
    Attribute: filter.orderBy,
    Descending: filter.descending || false,
  };
};
